import { Box } from '@mui/material'
import React, { PropsWithChildren } from 'react'

export const KaziLayout = ({children}: PropsWithChildren) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Box
            paddingX={'3%'}
            paddingTop={'4.5%'}
            height={'100%'}
        >
            {children}
        </Box>
    )
}